@defer {
    @if(authUser && authUser?.nickname){
        <app-event-bar></app-event-bar>
        <app-chat-widget (click)='hideMenu()' *ngFor='let activeRoomInfo of activeRoomsInfo; let i = index' [position]='i'
                         (closeRoom)='closeRoom($event)' [room]='activeRoomInfo.room' [roomId]='activeRoomInfo.roomId'
                         [isClosed]='!activeRoomInfo.openMessages'></app-chat-widget>
        <app-vote-form></app-vote-form>
        <app-chat-room-options-modal></app-chat-room-options-modal>
    }
} @placeholder {
    <div></div>
}

<router-outlet></router-outlet>

